module.exports = __webpack_public_path__ + "static/media/general-query.720e23ac.svg";